// @ts-nocheck
import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';

export interface ParentAccessRequest {
  id: string;
  parent_profile_id: string;
  athlete_profile_id: string;
  status: 'pending' | 'approved' | 'rejected';
  requested_at: string;
  parent?: {
    id: string;
    name: string;
    email: string;
  };
}

export const useParentAccessRequests = () => {
  const { profile } = useAuth();
  const [requests, setRequests] = useState<ParentAccessRequest[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (profile?.id) {
      fetchPendingRequests();
    }
  }, [profile?.id]);

  const fetchPendingRequests = async () => {
    if (!profile?.id) return;

    try {
      setLoading(true);
      // parent_athlete_relationships table doesn't exist in RLevents
      setRequests([]);
      return;

      const requestsWithParentInfo = (data || []).map(request => {
        // Access the first profile from the array if it exists
        const parentProfile = Array.isArray(request.profiles) ? request.profiles[0] : request.profiles;
        
        return {
          id: request.id,
          parent_profile_id: request.parent_profile_id,
          athlete_profile_id: request.athlete_profile_id,
          status: request.status as 'pending' | 'approved' | 'rejected',
          requested_at: request.requested_at,
          parent: parentProfile ? {
            id: parentProfile.id,
            name: parentProfile.name,
            email: parentProfile.email
          } : undefined
        };
      });

      setRequests(requestsWithParentInfo);
    } catch (error) {
      console.error('Error fetching parent access requests:', error);
    } finally {
      setLoading(false);
    }
  };

  const respondToRequest = async (requestId: string, response: 'approved' | 'rejected'): Promise<boolean> => {
    try {
      const { error } = await supabase
        .from('parent_athlete_relationships')
        .update({
          status: response,
          responded_at: new Date().toISOString()
        })
        .eq('id', requestId);

      if (error) {
        console.error('Error responding to parent access request:', error);
        return false;
      }

      // Refresh the requests list
      await fetchPendingRequests();
      return true;
    } catch (error) {
      console.error('Error responding to parent access request:', error);
      return false;
    }
  };

  return {
    requests,
    loading,
    refreshRequests: fetchPendingRequests,
    respondToRequest
  };
};
